import React from 'react';
import * as Yup from 'yup';
import { Trans } from '@lingui/macro';

import { Button, Checkbox, Field, Input } from '@economic/taco';

import { usePaymentCardsOnboardingDialog } from '../useOnboardingDialog';
import { CompanyInputProps } from '../types';
import { step2GetInputProps } from './config';

export const validationSchema = () =>
    Yup.object({
        cvr: Yup.string().required(),
        companyName: Yup.string().required(),
        country: Yup.string().required(),
    });

function CompanyInputField<T = string>({ error, label, type, name, ...props }: CompanyInputProps<T>) {
    const { state, updateCompanyInfo } = usePaymentCardsOnboardingDialog();
    const { formData } = state;

    if (type === 'checkbox' || typeof formData[name] === 'boolean') {
        const value = props.value as boolean;
        return (
            <Field>
                <Checkbox
                    {...props}
                    name={name}
                    value={String(value)}
                    checked={value}
                    onChange={value => updateCompanyInfo(value, name)}
                    label={label}
                />
            </Field>
        );
    }
    return (
        <div>
            <Field invalid={!!error} message={error}>
                {label}
                <Input
                    {...props}
                    name={name}
                    type={type}
                    value={formData[name] satisfies string}
                    onChange={ev => updateCompanyInfo(ev.currentTarget.value, name)}
                />
            </Field>
        </div>
    );
}

const PaymentCardsOnboardingDialogCompanyInformationStep1 = () => {
    const { state, openMasterSettings } = usePaymentCardsOnboardingDialog();
    const inputProps = React.useMemo(() => step2GetInputProps(state), [state]);

    return (
        <div className="flex flex-col gap-2 h-[477px] pb-2">
            <h2>
                <Trans>Your information</Trans>
            </h2>
            <Trans>
                Please validate your information before continuing. The following information will be shared with our partner
                Mynt.
            </Trans>
            <div className="pt-2">
                <div className="h-full flex flex-col gap-2 pt-2">
                    <CompanyInputField {...inputProps.cvr} />
                    <CompanyInputField {...inputProps.companyName} />
                    <CompanyInputField {...inputProps.country} />
                    <div className="flex justify-end pb-4">
                        <Button type="button" appearance="discrete" onClick={openMasterSettings}>
                            <Trans>Update master information</Trans>
                        </Button>
                    </div>
                    <CompanyInputField {...inputProps.agreeWithTerms} />
                </div>
            </div>
        </div>
    );
};

export default PaymentCardsOnboardingDialogCompanyInformationStep1;
